import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import SubTopic from "../PracticewithTs/SubTopic/SubTopic";
import TabLayout from "../PracticewithTs/TabLayout/TabLayout";
import TroubleSpots from "../PracticewithTs/TroubleSpots/TroubleSpots";
import Strength from "../Strength/Strength";
import style from "./ModuleSubtopic.module.css";
import { IoSearch } from "react-icons/io5";
import expand from "../../assests/expand.svg";
import collapse from "../../assests/collapse.svg";
import Trouble from "../Trouble/Trouble";
import LeftArrow from "../../assests/LeftArrow.png";

const ModuleSubtopic = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const {
    aiId = "",
    topicId = "",
    topicIndex = "",
    topicValue = "",
    moduleName = "",
    moduleIndex = "",
    selectedTab: initialTab = "all-skills",
    expandedModuleIndices = [],
    scrollToModuleIndex: scrollToModuleIndexFromState,
  } = location.state || {};

  const [skillsTab, setSkillsTab] = useState(initialTab);
  const [searchTerm, setSearchTerm] = useState("");
  const [allExpanded, setAllExpanded] = useState(false);

  const toggleAll = () => {
    setAllExpanded((prev) => !prev);
  };


  const handlePracticeAgain = () => {
    setSkillsTab("all-skills");
    setSearchTerm("");
  };

  const handleBack = () => {
    navigate("/new/learnings", {
      state: {
        initialSkillsTab: "all-skills",
        returnFromLearnOrSkill: true,
        expandedModuleIndices,
        scrollToModuleIndex:
          scrollToModuleIndexFromState ??
          (moduleIndex ? Number(moduleIndex) - 1 : undefined),
      },
    });
  };

  const topicTitle = String(topicValue || "").replace(/^Topic \d+:\s*/, "");

  return (
    <div className={style.container}>
      <div className={style.pageHeader}>
        <div className={style.headerIcon}>
          <img onClick={handleBack} src={LeftArrow} alt="Left" />
        </div>
        <div className={style.headerText}>
          <span>Exercise</span>
          <h4>
            {topicIndex ? `Topic ${topicIndex}: ` : ""}
            {topicTitle}
          </h4>
        </div>
      </div>

      <div className={style.headerWrapper}>
        <div className={style.tabsWrapper}>
          <div className={style.statusSection}>
              <div className={style.statusCard}>
                <span style={{ backgroundColor: "#00DFC7" }}></span>
                <p>Proficient</p>
              </div>
              <div className={style.statusCard}>
                <span style={{backgroundColor:"#FFCD64"}}></span>
                <p>Needs Practice</p>
              </div>
              <div className={style.statusCard}>
                <span style={{ backgroundColor: "#fa798ab7" }}></span>
                <p>Trouble Spots</p>
              </div>
            </div>
          {/* <TabLayout selectedTab={skillsTab} onTabChange={setSkillsTab} /> */}
        </div>

        {skillsTab === "all-skills" && (
          <div className={style.searchBox}>
            <input
              type="text"
              className={style.searchInput}
              placeholder="Search skills"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
            <button type="button" className={style.searchButton}>
              <IoSearch />
            </button>
          </div>
        )}
      </div>

      {skillsTab === "all-skills" && (
        <>
          <div className={style.subheadContainer}>

            <div className={style.expandAndCollapse}>
              <div className={style.subheadWrapper} onClick={toggleAll}>
                <img src={allExpanded ? collapse : expand} alt="toggle" />
                <p>{allExpanded ? "Collapse All" : "Expand All"}</p>
              </div>
            </div>
          </div>

          <SubTopic
            onBack={handleBack}
            aiId={aiId}
            topicId={topicId}
            topicIndex={topicIndex}
            topicValue={topicValue}
            moduleName={moduleName}
            moduleIndex={moduleIndex}
            searchTerm={searchTerm}
            expandAll={allExpanded}
            showPageHeader={false}
          />
        </>
      )}

      {skillsTab === "trouble-spots" && (
        <Trouble/>
      )}

      {skillsTab === "Strength" && (
       <Strength/>
      )}

    </div>
  );
};

export default ModuleSubtopic;
